import * as types from './mutation-types';
import objToURI from '@/clir/utils/encodeData';
import getKey from '@/clir/utils/getKey';

const baseURL = `/${process.env.VUE_APP_APPLICATION_NAME}/api`;

const parseUserResponse = async (res) => {
    try {
        const body = await res.json();
        const id = body.uid;
        let permissions = {};
        const listeHabilitations = getKey(body, 'listeHabilitations', false);
        if (listeHabilitations) {
            listeHabilitations.forEach(elem => {
                const nomProfil = getKey(elem, 'nomProfil', null);
                if (nomProfil) permissions[nomProfil] = elem;
            });
        }
        delete body.userPassword;
        delete body.uid;
        const profil = { ...body };
        return {
            id,
            profil,
            permissions,
        };
    } catch (e) {
        throw e;
    }
};

export default {
    reset: ({ commit, dispatch }) => {
        commit(types.SET_TOKEN, null);
        dispatch('user/reset', null, { root: true });
    },
    login: async ({ commit, dispatch }, data) => {
        const body = objToURI(data);
        const payload = {
            url: `${baseURL}/j_spring_security_check_backend`,
            options: {
                method: 'POST',
                headers: [["Content-Type", "application/x-www-form-urlencoded; charset=UTF-8"]],
                body,
            },
        };
        try {
            const res = await dispatch('fetch/DGFiPFetch', payload, { root: true });
            const token = res.headers.get('X-XSRF-TOKEN') || res.headers.get('X-CSRF-TOKEN') ||  res.headers.get('xsrf-token');
            commit(types.SET_TOKEN, token);
            await dispatch('user/setAuth', true, { root: true });
            const user = await dispatch('getMe');
            await dispatch('user/setMe', user, { root: true });
            return true;
        } catch (e) {
            throw e;
        }
    },
    getMe: async ({dispatch}) => {
        const payload = {
            url: `${baseURL}/tech/utilisateur`,
            options: { method: 'GET' },
        };
        try {
            const me = await dispatch('fetch/DGFiPFetch', payload, { root: true });
            const myUser = await parseUserResponse(me);
            return myUser;
        } catch (e) {
            throw e;
        }
    },
    authMe: async ({ dispatch, commit, getters }, data) => {
        const token = getKey(data, 'query.token', null) || getters.token || sessionStorage.getItem('tokenClir');
        try {
            if (token) {
                const user = await dispatch('getMe');
                commit(types.SET_TOKEN, token);
                await dispatch('user/setMe', user, { root: true });
                return true;
            }
            return false;
        } catch (e) {
            return false;
        }
    },
    logout: async ({ dispatch }) => {
        const payload = {
            url: `${baseURL}/logout`,
            options: {
                method: "POST",
                headers: [["Content-Type", "application/x-www-form-urlencoded; charset=UTF-8"]],
            },
        };
        try {
            await dispatch('fetch/DGFiPFetch', payload, { root: true });
            sessionStorage.removeItem('tokenClir');
            await dispatch('reset');
            return true;
        } catch (e) {
            throw e;
        }
    },
    getHeaders: ({ getters }) => {
        return {
            'X-XSRF-TOKEN': `${getters.token}`
        }
    }
};